import AbstractEntity from "../AbstractEntity";

export default class Order extends AbstractEntity {
    static STATUS_TO_SUGGEST = 0;
    static STATUS_SUGGESTED = 1;
    static STATUS_IN_PROGRESS = 2;
    static STATUS_CLOSED = 3;
    static STATUS_CHECKED = 4;
    static STATUS_ABORTED = 5;

    static ABORT_REASON_UNKNOW = 0;

    _id;
    _prescriberId;
    _workId;
    _externalId;
    _description;
    _status;
    _abortReason;
    _deductible;
    _maxPrice;
    _clientContacted;
    _createdAt;
    _statusSuggestedAt;
    _statusInProgressAt;
    _statusClosedAt;
    _statusCheckedAt;
    _statusAbortedAt;
    _clientId;


    getId() {
        return this._id;
    }

    getPrescriberId() {
        return this._prescriberId;
    }

    getWorkId() {
        return this._workId;
    }

    getExternalId() {
        return this._externalId;
    }

    getDescription() {
        return this._description;
    }

    getStatus() {
        return this._status;
    }

    getAbortReason() {
        return this._abortReason;
    }

    getDeductible() {
        return this._deductible;
    }

    getMaxPrice() {
        return this._maxPrice;
    }

    isClientContacted() {
        return this._clientContacted;
    }

    getCreatedAt() {
        return this._createdAt;
    }

    getStatusSuggestedAt() {
        return this._statusSuggestedAt;
    }

    getStatusInProgressAt() {
        return this._statusInProgressAt;
    }

    getStatusClosedAt() {
        return this._statusClosedAt;
    }

    getStatusCheckedAt() {
        return this._statusCheckedAt;
    }

    getStatusAbortedAt() {
        return this._statusAbortedAt;
    }

    getClientId() {
        return this._clientId;
    }

    getClassName() {
        return "order";
    }
}
